<template>
  <div id="tutorial-container" v-if="isVisible">
    <div id="tutorial">
      <iframe
        width="711"
        height="400"
        src="https://www.youtube.com/embed/16IpkM7ueWU?rel=0&amp;showinfo=0"
        frameborder="0"
        allowfullscreen
      />
    </div>
    <p @click="toggleVisibility">Cerrar tutorial</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false
    };
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    }
  }
};
</script>
